import { Box, FormControlLabel } from '@mui/material';
import React from 'react';
import { DynamicQuestionControl } from './DynamicQuestionControl';

export const DynamicQuestionSingle = ({
    question,
    truth,
    answer,
    disabled,
    onChange
}) => {
    return <div>
        <div className="fs-20 fw-semi-bold" style={{whiteSpace: 'pre-line'}}>{question.name}</div>
        <Box className="dynamic-question-content" display="flex" flexDirection="column">
            {question.options.map((option) =>{
                const isTruth = truth === option.id;
                const isAnswer = answer === option.id;


                return <FormControlLabel
                    style={{alignItems: 'flex-start'}}
                    key={option.id}
                    value={option.id}
                    label={option.name}
                    control={<DynamicQuestionControl type="radio" isAnswer={isAnswer} isTruth={isTruth} disabled={disabled} />}
                    checked={isTruth || isAnswer}
                    onChange={() => onChange(option.id)}
                />;
            })}
        </Box>
    </div>;
};
